export default "__VITE_ASSET__DvY6SfrW__"